/**
 * Used to show 3rd party developers integrating Booking engine as a widget that they did something wrong.
 * Do not use it for internal logging. For internal logging, consider these instead: loggerService, logSentryError.
 * @param message - message to be logged
 */
export function logError(message: string) {
    console.error('Distributor: %s', message); // eslint-disable-line no-console
}
